module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-date-picker', {
    attrs: {
      "value": _vm.inner_value,
      "type": "date",
      "clearable": _vm.clearable,
      "editable": _vm.editable,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "size": _vm.size,
      "placeholder": _vm.placeholder,
      "pickerOptions": _vm.options
    },
    on: {
      "input": _vm.update
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8d9f502","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/basic/Datepicker.vue
// module id = 311
// module chunks = 0